import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const LoginRoute = () => {
  const { user, token } = useAuth();
  const location = useLocation();

  if (user && token) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  return <Outlet />; 
};